import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceMonitoringService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-monitoring`;

    static getInstance() {
        if (!ComplianceMonitoringService.instance) {
            ComplianceMonitoringService.instance = new ComplianceMonitoringService();
        }

        return ComplianceMonitoringService.instance;
    }

    async addToMonitoringList(payload = {}) {
        const response = await axios.post(`${this.resource}/add`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
                "Content-Type": "application/json"
            }
        });

        return response.data;
    }

    async addPersonToMonitoringList(payload) {
        const response = await axios.post(
            `${this.resource}/person/add`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }

    async removePersonFromMonitoringList(personId, params = {}) {
        return await axios.delete(`${this.resource}/follow-list-item/${personId}`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
    }

    async fetchSupplierComplianceMonitoringResult(supplierId, params = {}) {
        const response = await axios.get(
            `${this.resource}/${supplierId}/fetch`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async fetchAlertDetails(alertId, params = {}) {
        const response = await axios.get(
            `${this.resource}/alerts/${alertId}/fetch`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async updateAlertFalsePositive(payload) {
        const response = await axios.post(
            `${this.resource}/alerts/mark_false_positive`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }

    async toggleMonitoring(monitoringId, payload = {}) {
        const response = await axios.post(
            `${this.resource}/follow-list-item/${monitoringId}/toggle-active`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }
}
